module.exports = __webpack_public_path__ + "img/heart_full.7a66e8a5.svg";